<template>
  <pu-accordion-stateless
    :transition-name="transitionName"
    :value="selected"
    :accordion-id="accordionId"
    @input="toggle($event)"
  >
    <template v-for="(slot, index) of Object.keys($slots)" :key="index" #[slot]>
      <slot :name="slot" />
    </template>
  </pu-accordion-stateless>
</template>

<script lang="ts">
import { Component, Prop, toNative, Vue } from '~/utility/pu-class-decorator'

@Component({
  emits: ['accordion-open', 'accordion-close'],
})
class PuAccordion extends Vue {
  @Prop({ default: false })
  selected!: boolean

  @Prop({ type: String, default: 'fade' })
  transitionName!: string

  @Prop({ type: String, required: true })
  accordionId: string

  async mounted() {
    await this.$nextTick(function () {
      if (this.selected) {
        this.$emit('accordion-open', this.$el)
      }
    })
  }

  toggle($event: any) {
    if (this.selected) {
      this.$emit('accordion-close', $event)
    } else {
      this.$emit('accordion-open', $event)
    }
  }
}

export default toNative(PuAccordion)
</script>
